export const searchFetch = {
  itemCountToFetch: 10
}

export const ratingColorConfig = {
  1: "red",
  2: "yellow",
  3: "greenDr",
  4: "greenLt",
  5: "greenLt"
}

export const srpColorConfig = {
  1: "#ff3a5c",
  2: "#f39c12",
  3: "#79d148",
  4: "#18a160",
  5: "#18a160"

}

export function getIconName(key) {
  const obj = {
    'Emergency Contact Number': 'emergency-contact',
    'Movie': 'Movie',
    'Water Bottle': 'WaterBottle',
    'Blankets': 'Blankets',
    'Charging Point': 'ChargingPoint',
    'Reading Light': 'ReadingLight',
    'NA': 'DefaultAmenitiesIcon',
    'Snacks': 'Snacks',
    'WIFI': 'Wifi',
    'CCTV': 'CCTV',
    'Pillow': 'Pillow',
    'Toilet': 'Toilet',
    'Meal': 'Meal',
    'Personal TV': 'PersonalTv',
    'Headsets': 'Headsets',
    'Newspaper': 'Newspaper',
    'Tour Guide': 'TourGuide',
    'default': 'DefaultAmenitiesIcon',
    'Regular temperature checks': 'thermameter',
    'Hand Sanitisers Provided': 'hand-sanitiser',
    'Staff with masks': 'facemask',
    'No blankets/linens': 'noblanket',
    'Deep Cleaned Buses': 'deep-clean',
    'Bathroom': 'Bathroom',
    'Heater': 'Heater',
    'No Amenities': 'DefaultAmenitiesIcon',
    'Satellite': 'Satellite',
    'Food': 'Food',
    'Massage chair': 'MassageChair',
    'Track My Bus': 'TrackMyBus',
    'Facial Tissues': 'FacialTissues',
    'Soft drink': 'SoftDrink',
    'Emergency exit': 'EmergencyExit',
    'Fire Extinguisher': 'FireExtinguisher',
    'Hammer (to break glass)': 'Hammer',
    'Bus Hostess': 'BusHostess',
    'Central TV': 'CentralTV',
    'Cup holder': 'CupHolder',
    'Music/MP3': 'MusicMp3',
    'Reclining seat': 'RecliningSeat',
    'Safety belt': 'SafetyBelt',
    'Smoking room': 'SmokingRoom',
    'Wet Napkin': 'WetNapkin',
    'AIR  CONDITIONER': 'AirConditioner',
    'No blankets': 'noblanket',
    'gps': 'LiveBus',
    'soc_dis': 'SocialDistanceIcon',
    'go_safe': 'GoSafeIcon',
    'reddeal': 'OffersIcon',
    'rating': 'TopRatedIcon',
    'zct_msg': 'FreeCancellationIcon',
  };
  return obj[key] || obj['default'];
}
